"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSICURAZIONE_AUTO_ADV_TEMPLATE_LAYOUT_TYPE = exports.QUOTATORI_FORM_TEMPLATE_LAYOUT_TYPE = exports.PREVENTIVATORE_AUTO_FORM_TEMPLATE_LAYOUT_TYPE = exports.UTILE_A_SAPERSI_FOGLIA_TEMPLATE_LAYOUT_TYPE = exports.CUSTOM_TEMPLATE_LAYOUT_TYPE = exports.CONFIGURATORE_CASA_FORM_LAYOUT_PLACEMENT_TYPE = exports.CONFIGURATORE_CASA_FORM_LAYOUT_TYPE = exports.HP_TEMPLATE_LAYOUT_TYPE = exports.SINGLE_COLUMN_LAYOUT_TYPE = exports.ONECOLUMN_TEMPLATE_LAYOUT_TYPE = void 0;
exports.ONECOLUMN_TEMPLATE_LAYOUT_TYPE = "layout-templates/1Column/";
exports.SINGLE_COLUMN_LAYOUT_TYPE = "SingleColumnLayout";
exports.HP_TEMPLATE_LAYOUT_TYPE = "layout-templates/hp/";
exports.CONFIGURATORE_CASA_FORM_LAYOUT_TYPE = "ConfiguratoreCasaFormLayout";
exports.CONFIGURATORE_CASA_FORM_LAYOUT_PLACEMENT_TYPE = {
    BOX_REASON_WHY: "Box_reason_why",
};
exports.CUSTOM_TEMPLATE_LAYOUT_TYPE = "dav:fs-type1/layout-templates/Custom/";
exports.UTILE_A_SAPERSI_FOGLIA_TEMPLATE_LAYOUT_TYPE = "layout-templates/UtileASapersiFoglia/";
exports.PREVENTIVATORE_AUTO_FORM_TEMPLATE_LAYOUT_TYPE = "layout-templates/PreventivatoreAutoForm/";
exports.QUOTATORI_FORM_TEMPLATE_LAYOUT_TYPE = "layout-templates/quotatoriForm/";
exports.ASSICURAZIONE_AUTO_ADV_TEMPLATE_LAYOUT_TYPE = "layout-templates/AssicurazioneAutoAdv/";
